import React from 'react'
import { notifyError } from './utils/appToast'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Catches render errors: notify with a toast and keep the tree mounted when possible.
 */
class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('React ErrorBoundary:', error, errorInfo)
    const msg = error?.message || 'Something went wrong. Try refreshing the page.'
    notifyError(msg.length > 160 ? `${msg.slice(0, 157)}…` : msg, { autoClose: 6000 })
    this.setState({ hasError: false })
  }

  render() {
    return this.props.children
  }
}

export default ErrorBoundary

